import {
    lazyCleanUpPlacesIndexedDB,
    lazyCleanUpPlacesLocalStorage,
    lazyCleanUpPlacesSessionStorage,
} from './lazyFunctions';

export async function executeSignoutPromises(): Promise<void> {
    await Promise.all([
        lazyCleanUpPlacesLocalStorage.importAndExecute(),
        lazyCleanUpPlacesSessionStorage.importAndExecute(),
        lazyCleanUpPlacesIndexedDB.importAndExecute(),
    ]);
}
